import React, { useState } from 'react';
import PropTypes from 'prop-types';

import capitalize from 'lodash/capitalize';

import Body from './body';
import Button from 'shared/button';
import Modal from 'components/modal';

import './styles.scss';

export default function CompSelectorModal({ coordinates, defaultSelectedComps, show, type, onCancel, onSave }) {
  if (!show) {
    return null;
  }

  const [saving, setSaving] = useState();
  const [selectedComps, setSelectedComps] = useState(defaultSelectedComps || []);

  function save() {
    setSaving(true);
    onSave(selectedComps);
  }

  return (
    <Modal className="comp-selector-modal" show size="xl" onHide={onCancel}>
      <Modal.Header closeButton>
        Select {capitalize(type)} Comps
      </Modal.Header>

      <Modal.Body>
        <Body
          coordinates={coordinates}
          selectedComps={selectedComps}
          type={type}
          onSelectedCompsChange={setSelectedComps}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button.Cancel onClick={onCancel} />
        <Button.Primary disabled={saving} name="save" onClick={save}>Save</Button.Primary>
      </Modal.Footer>
    </Modal>
  );
}

CompSelectorModal.propTypes = {
  coordinates: PropTypes.object,
  defaultSelectedComps: PropTypes.array,
  show: PropTypes.bool,
  type: PropTypes.string,
  onCancel: PropTypes.func,
  onSave: PropTypes.func.isRequired,
};
